export const SEO_BRAND_KIT = {
  keywordUniverse: {
    coreBrandKeywords: [
      'l3v3l matches',
      'level matches',
      'level matchmaking',
      'level matrimony',
      'level marriage platform',
      'level compatibility matching',
      'level verified profiles',
      'level premium matrimony',
      'level match engine',
      'level compatibility score',
      'level relationship matching',
      'level indian matrimony usa'
    ],
    matrimonyAndMatchmakingKeywords: [
      'matrimony',
      'matrimonial services',
      'matchmaking',
      'marriage matching',
      'partner search',
      'life partner search',
      'marriage platform',
      'marriage biodata',
      'matrimonial biodata',
      'compatibility matching',
      'relationship compatibility',
      'long-term relationship matching',
      'marriage-focused matchmaking',
      'verified matrimonial profiles',
      'authentic matchmaking',
      'community-based matchmaking',
      'premium matchmaking',
      'modern matrimony',
      'digital matrimony',
      'smart matchmaking',
      'ai-powered matchmaking',
      'ai compatibility scoring'
    ],
    indianOriginAndCulturalKeywords: [
      'indian-origin families',
      'indian-american matrimony',
      'indian diaspora matchmaking',
      'indian community matchmaking',
      'indian heritage matchmaking',
      'indian culture compatibility',
      'indian values matchmaking',
      'indian-origin singles',
      'indian-origin professionals',
      'indian-origin marriage platform',
      'indian-origin us citizens',
      'indian-origin green card holders',
      'indian-origin families in usa',
      'indian-origin matrimonial service'
    ],
    usBasedEligibilityKeywords: [
      'us citizens',
      'green card holders',
      'permanent residents',
      'us-based indian families',
      'us-based indian singles',
      'verified us identity',
      'us-only matrimonial platform',
      'us-exclusive matchmaking',
      'us-based matchmaking service'
    ],
    safetyTrustVerificationKeywords: [
      'verified profiles',
      'authentic profiles',
      'community-reviewed profiles',
      'identity verification',
      'safe matchmaking',
      'trusted matrimonial platform',
      'secure matchmaking',
      'profile authenticity',
      'community trust',
      'high-trust matrimony',
      'verified biodata',
      'profile screening',
      'community moderation',
      'safe matrimonial experience'
    ],
    lifestyleCompatibilityKeywords: [
      'values alignment',
      'cultural alignment',
      'lifestyle compatibility',
      'relationship potential',
      'long-term compatibility',
      'family values',
      'shared upbringing',
      'shared culture',
      'shared roots',
      'shared future',
      'compatibility factors',
      'personality matching',
      'education compatibility',
      'career compatibility',
      'family background compatibility'
    ],
    premiumPositioningKeywords: [
      'premium matrimonial platform',
      'exclusive matrimonial service',
      'high-quality matches',
      'curated matches',
      'elite matchmaking',
      'modern premium matrimony',
      'high-trust premium community',
      'premium indian-origin matchmaking',
      'no-limits premium features',
      'free premium access',
      'unlimited premium features'
    ],
    searchAndDiscoveryKeywords: [
      'find your match',
      'discover compatible profiles',
      'search verified profiles',
      'explore matches',
      'smart match suggestions',
      'personalized match recommendations',
      'ai match suggestions',
      'compatibility-based search'
    ],
    eventAndCommunityKeywords: [
      'community matchmaking',
      'family-oriented matchmaking',
      'indian community events',
      'matrimonial meetups',
      'matrimonial introductions',
      'community-curated matches'
    ],
    marketingAndMessagingKeywords: [
      'meaningful connections',
      'long-term relationships',
      'marriage-ready singles',
      'genuine profiles',
      'authentic connections',
      'shared values',
      'shared culture',
      'trusted community',
      'modern indian matchmaking',
      'us-based indian matrimony'
    ],
    longTailKeywords: [
      'indian-origin us citizens matrimonial service',
      'matrimony for indian-origin green card holders',
      'verified indian matrimonial profiles in usa',
      'premium indian matchmaking for us residents',
      'ai-powered indian matrimonial platform',
      'indian-american marriage matchmaking',
      'matrimonial service for indian families in usa',
      'best matrimonial platform for indian-origin singles in america'
    ]
  },
  taglineOptions: [
    'Verified. Curated. Community-trusted.',
    'Where US-based Indian families find trusted matches.',
    'Premium matchmaking for Indian-origin US citizens.',
    'Authentic profiles. Meaningful connections.',
    'Trusted matrimony for Indian-origin professionals.',
    'Verified matches for marriage-ready singles.',
    'Community-reviewed profiles you can trust.',
    'Matrimony built for safety, clarity, and trust.',
    'Genuine profiles. Real families. True compatibility.',
    'The premium matrimonial platform for Indian-origin families.',
    'Smart matchmaking for modern Indian-origin singles.',
    'AI-guided compatibility for meaningful relationships.',
    'Modern matrimony for US-based Indian families.',
    'Intelligent matchmaking for long-term compatibility.',
    'AI-powered matching with verified profiles.',
    'Smart, secure, and marriage-focused matchmaking.',
    'Compatibility scoring built for real relationships.',
    'Modern matchmaking rooted in culture and values.',
    'Built for Indian-origin families in the USA.',
    'Where culture meets compatibility.',
    'Marriage-focused matchmaking for Indian-origin singles.',
    'Shared values. Shared roots. Shared future.',
    'Community-led matchmaking for Indian-origin families.',
    'US-based Indian matrimony done right.',
    'Find your match within your community.',
    'Search with confidence.',
    'Verified matches only.',
    'Marriage-ready profiles.',
    'Trusted Indian-origin matrimony.',
    'Premium US-based matchmaking.',
    'Smart matches. Real people.',
    'Compatibility that matters.'
  ],
  metaDescriptionOptions: [
    'L3V3L Matches is a premium, verified matrimonial platform for US-based Indian-origin families. Find genuine, marriage-ready matches with cultural compatibility.',
    'Discover trusted, curated matrimonial profiles for Indian-origin US citizens. Verified biodata, smart matchmaking, and community-reviewed matches.',
    'A modern matrimonial service for Indian-origin singles in the USA. Verified profiles, AI-powered compatibility, and safe matchmaking.',
    'Find your life partner with verified Indian-origin matrimonial profiles. Built for US citizens and Green Card holders seeking meaningful relationships.',
    'Premium matchmaking for Indian-origin families in America. Authentic profiles, cultural alignment, and marriage-focused connections.',
    'L3V3L Matches offers safe, verified matrimonial matchmaking for Indian-origin professionals in the USA. Trusted profiles and curated matches.',
    'Search genuine matrimonial profiles for Indian-origin US residents. Smart compatibility scoring and community-trusted verification.',
    'A secure matrimonial platform for Indian-origin families. Verified biodata, curated matches, and modern matchmaking tools.',
    'Find culturally aligned, marriage-ready matches with verified Indian-origin profiles. Built for US-based families seeking trust and authenticity.',
    'Premium Indian-origin matrimony for US citizens. Verified profiles, compatibility scoring, and trusted community-led matchmaking.'
  ],
  adCopyVariants: {
    shortPerformance: [
      'Verified Indian-origin matches in the USA. Join today.',
      'Trusted matrimonial profiles for US-based Indian families.',
      'Marriage-ready singles. Verified biodata. Real compatibility.',
      'Premium Indian-origin matchmaking for US citizens.',
      'Smart, safe, and culturally aligned matches.'
    ],
    medium: [
      'Looking for a trusted matrimonial platform? L3V3L Matches offers verified Indian-origin profiles for US citizens and residents.',
      'Find genuine, marriage-ready matches with cultural compatibility. Verified profiles only - no spam, no fake accounts.',
      'A premium matrimonial service built for Indian-origin families in the USA. Discover curated, community-trusted matches.'
    ],
    long: [
      'L3V3L Matches is the premium matrimonial platform for Indian-origin families in the USA. Every profile is verified, community-reviewed, and marriage-ready. Discover smart compatibility scoring, cultural alignment, and trusted matchmaking designed for long-term relationships.',
      'Searching for a life partner with shared values and cultural roots? L3V3L Matches connects Indian-origin US citizens and residents through verified profiles and curated matchmaking. Safe, modern, and community-trusted.'
    ]
  },
  dashboardCategoryLabels: {
    profileCategories: [
      'Verified Profiles',
      'New Profiles',
      'Marriage-Ready',
      'Indian-Origin US Citizens',
      'Green Card Holders',
      'Professionals',
      'Families',
      'Community-Reviewed',
      'High Compatibility',
      'Recently Active'
    ],
    matchCategories: [
      'Recommended Matches',
      'High Compatibility Matches',
      'Cultural Alignment Matches',
      'Lifestyle Alignment',
      'Education Compatibility',
      'Career Compatibility',
      'Family Background Match',
      'Premium Matches',
      'Curated Matches',
      'Community-Trusted Matches'
    ],
    safetyAndVerification: [
      'Identity Verified',
      'Biodata Verified',
      'Community Verified',
      'Safe Profiles',
      'Flagged Profiles',
      'Moderation Queue'
    ],
    eventsAndEngagement: [
      'Community Events',
      'Matrimonial Meetups',
      'Introductions',
      'Family-Requested Matches',
      'New Connections'
    ]
  },
  platformTaxonomy: {
    userIdentity: {
      citizenship: ['US Citizen', 'Green Card Holder', 'US Resident'],
      indianOriginCategory: ['Indian-American', 'Indian-origin professional', 'Indian diaspora'],
      familyType: ['Nuclear', 'Joint', 'Traditional', 'Modern']
    },
    profileVerification: [
      'Identity Verification',
      'Biodata Verification',
      'Community Verification',
      'Employment Verification',
      'Education Verification'
    ],
    compatibilityDimensions: [
      'Cultural Compatibility',
      'Lifestyle Compatibility',
      'Values Alignment',
      'Family Expectations',
      'Education',
      'Career',
      'Personality',
      'Long-term Goals',
      'Religious / Spiritual Alignment'
    ],
    matchmaking: [
      'Recommended Matches',
      'High Compatibility',
      'Curated Matches',
      'Premium Matches',
      'Community-Trusted Matches',
      'Marriage-Ready Matches',
      'New Matches',
      'Recently Active Matches'
    ],
    searchFilters: [
      'Age',
      'Citizenship Status',
      'Indian-Origin Category',
      'Education Level',
      'Profession',
      'Location (US State / Metro)',
      'Family Background',
      'Religion / Spirituality',
      'Height',
      'Lifestyle Preferences',
      'Dietary Preferences'
    ],
    safetyAndModeration: [
      'Verified Profiles',
      'Flagged Profiles',
      'Reported Profiles',
      'Moderation Queue',
      'Community Feedback',
      'Profile Authenticity Score'
    ],
    engagement: [
      'Likes',
      'Intros',
      'Messages',
      'Family Requests',
      'Shortlist',
      'Profile Views',
      'Event Participation'
    ]
  }
};

export const SEO_KEYWORD_UNIVERSE = SEO_BRAND_KIT.keywordUniverse;

export const createKeywordList = (...keywordGroups) => {
  return [...new Set(keywordGroups.flat().filter(Boolean))];
};

export const createKeywordString = (...keywordGroups) => {
  return createKeywordList(...keywordGroups).join(', ');
};

export default SEO_BRAND_KIT;
